exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#000}h1{color:red}p{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/komponente/ishod/stil-mrtav.css
// module id = 29
// module chunks = 0